

<div class="row">
  <div class="col-md-12 col-xl-12  my-profile-form ">
    <div class="card">
      <div class="card-header background-white pad4">
        <div class="row">
          <div class="col-md-12">
            <label class="title font-size-20px margin-top-0px margin-bottom-0px">Edit Consumtion Group</label>
            <button type="button" class="close button:focus" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>

      </div>
      <form class="form " novalidate="" #f="ngForm">
        <div class="card-body">
          <!--<div class="row my-pro-form margin-t-form">
            <div class="form-group col-md-12 col-xs-12 margin-top-10 margin-bottom-10px">
              <div class="row">
                <div class="col-md-3 text-align-right">
                  <label class="lab-size1"> Name </label>
                </div>
                <div class="col-md-6">

                  <input type="text" class="form-control" placeholder="Name"
                         id="CurrentSaveCodeTypeRequest.Name"
                         [(ngModel)]="CurrentSaveCodeTypeRequest.Name" required
                         name="CurrentSaveCodeTypeRequest.Name" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                         maxlength="100" />
                  <small class="form-text text-danger"
                         *ngIf="(!RecommendedPackage.valid && RecommendedPackage.errors.pattern)">(special characters are not allowed)</small>


                </div>


              </div>

            </div>
          </div>
          <div class="row my-pro-form margin-t-form">
            <div class="form-group col-md-12 col-xs-12 margin-top-10 margin-bottom-10px">
              <div class="row">
                <div class="col-md-3 text-align-right">
                  <label class="lab-size1"> Short Name </label>
                </div>
                <div class="col-md-6">

                  <input type="text" class="form-control" placeholder="Name"
                         id="CurrentSaveCodeTypeRequest.ShortName"
                         [(ngModel)]="CurrentSaveCodeTypeRequest.ShortName" required
                         name="CurrentSaveCodeTypeRequest.ShortName" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                         maxlength="100" />
                  <small class="form-text text-danger"
                         *ngIf="(!RecommendedPackage.valid && RecommendedPackage.errors.pattern)">(special characters are not allowed)</small>


                </div>


              </div>

            </div>
          </div>-->
          <div class="row  ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Group Name</label>
                </div>


                <div class="col-md-6">
                  <input type="text" class="form-control" placeholder="Group Name"
                         pattern="^[\0-9,._\-?]*$">

                </div>
              </div>


            </div>
          </div>
          <div class="row  ">
            <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
              <div class="row">
                <div class="col-md-4 text-align-right margin-tg-auto">
                  <label for="diaplayName" class="font-size-12px margin-bottom-0px">Select Procedure</label>
                </div>


                <div class="col-md-6">
                  <CodeTypeValue CodeType="NPRE"></CodeTypeValue>

                </div>
              </div>


            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="row margin-top-30px margin-bottom-30px">

            <div class="col-md-6 padding-left-0px padding-right-24px">
              <button class="btn bs hover1 nav-link-hand font-size-14px width3 padding-bottom-0px padding-top-0px padding-left-8px float-right" (click)="activeModal.dismiss('Cross click')" type="button">Cancel</button>
            </div>
            <div class="col-md-6 padding-left-0px padding-right-24px">
              <button type="submit" class="btn btn-primary hover1 nav-link-hand font-size-14px width3 padding-bottom-0px padding-top-0px float-left">Save</button>
            </div>

          </div>

        </div>
        </form>
    </div>

  </div>
</div>





